import { render, staticRenderFns } from "./FeatureHeadlines.vue?vue&type=template&id=00dfe7bb&"
import script from "./FeatureHeadlines.vue?vue&type=script&lang=js&"
export * from "./FeatureHeadlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports